import React, { Suspense } from 'react';
import { Outlet, RouterProvider } from 'react-router';
import { createBrowserRouter } from 'react-router-dom';
import routes from './router/routes';

const router = createBrowserRouter([
  {
    element: (
      <Suspense fallback={<h1>Loading...</h1>}>
        <Outlet />
      </Suspense>
    ),
    children: routes,
  },
]);

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;
